<template>
  <li class="CrudItem" :class="{editable}">
    <FormCustomRadio v-if='selectable'
      @radio-click="$emit('select')"

      :value="active"
    >
      {{ name.replace(name.split('_').shift() + '_', '') }}
    </FormCustomRadio>
    <div v-else class='item-content d-flex align-items-center'>
      <span class="ske m-1">
        {{ name.replace(name.split('_').shift() + '_', '') }}
      </span>
      <span v-if='showDate' class='info'>
        {{ formatted }}
      </span>
    </div>

    <div class="delete-item d-flex align-items-center">
      <button v-if='!loadingItems && actionTitle' class="d-flex align-items-center mr-1" @click="$emit('action')">
        <span>{{ actionTitle }}</span>
      </button>

      <svg @click="$emit('remove')" width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
    </div>
  </li>
</template>

<script>

import FormCustomRadio from "../../../../components/Inputs/FormCustomRadio.vue"

import { format } from 'date-fns'

export default {
  components: {
    FormCustomRadio,
  },
  props: {
    name: String,
    createdAt: String,
    actionTitle: String,
    active: Boolean,
    showDate: Boolean,
    selectable: Boolean,
    editable: Boolean,
    loadingItems: Boolean,
  },
  computed: {
    formatted() {
      try {
        return this.createdAt && format(new Date(this.createdAt), "dd-MM-yyyy HH:mm")
      } catch (err) {
        return this.createdAt
      }
    },
  },
}

</script>

<style scoped>

.info {
  color: rgb(160,160,160);
}

button {
  border-radius: 6px;
  font-weight: 500;
  padding: 4px 6px;
  border: 1px solid rgb(228,228,228);
}

button:hover {
  background-color: rgb(251,251,251);
}


.item-content {
  display: block;
}

.delete-item {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 8px;
}

svg {
  color: var(--black-70);
  transition-duration: .15s;
}

svg:hover {
  color: #212529;
}

li {
  position: relative;
  list-style: none;
  padding: 3px 6px;
  background-color: white;
  transition-duration: .15s;
}

.editable {
  cursor: pointer;
}

li:hover {
  background-color: #f8f9fa;
}

li + li {
  border-top: 1px solid #E3E3E3;
}

</style>

<style>

.CrudItem .name {
  padding: 4px 0;
}

</style>
